
<div class="col-xs-12 spark-message spark-message--error showLoginErrMsg"  *ngIf= "error()">
    <i class="spark-message__icon spark-icon-ban spark-icon--fill"></i>
    <p class="spark-message__content">
      {{errorMsg()}}
    </p>
  </div>
